module.exports = __webpack_public_path__ + "media/images/icons/right-arrow-77e8b4f3ec25095399908776a0893b83.svg";